module.exports = __webpack_public_path__ + "static/yuan_ti_abomination-09944d8768f8bc8ca62d97d4754f6ee7.jpg";